import React from 'react';

import { logoUSKidsHorizontal, logoUSKidsPortrait } from '@/assets/images';
import { Image, type ImageProps } from '@/components/ui';
import { useScaling } from '@/hooks';

type AuthBrandLogoProps = {
  /** Design width in px (auto-scaled). Default 196. */
  width?: number;
  /** Design height in px (auto-scaled). Default 32. */
  height?: number;
  resizeMode?: ImageProps['resizeMode'];
  portrait?: boolean;
};

/** U.S. Kids Golf horizontal wordmark used across the auth flow. */
export function AuthBrandLogo({
  width = 242,
  height = 40,
  portrait = false,
  resizeMode = 'contain',
}: AuthBrandLogoProps) {
  const { scale } = useScaling();
  return (
    <Image
      source={portrait ? logoUSKidsPortrait : logoUSKidsHorizontal}
      width={scale(width)}
      height={scale(height)}
      resizeMode={resizeMode}
    />
  );
}

export default AuthBrandLogo;
